export default "__VITE_ASSET__a49f79fc__"